// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1BxH_","subheader":"ReorderModal_subheader__lyxn_","listWrap":"ReorderModal_listWrap__Gvwec"};